module.exports = __webpack_public_path__ + "img/lunchly_menu1.e8e08695.png";